<template>
  <el-dialog center title="" :visible.sync="dialogVisible" :show-close="false" :before-close="beforeClose"
    custom-class="secondary-confirmation" :width="width">
    <div class="main-dialog-content">
      <div class="warn-img">
        <img src="@/assets/images/warning.png" />
      </div>
      <!-- <div class="text">提示</div> -->
      <slot></slot>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogCancel" type="text" class="cancel-button">取 消</el-button>
      <el-button @click="dialogConfirm" type="text" class="confirm-button">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    width: {
      default: "25%"
    }
  },
  methods: {
    dialogCancel() {
      this.$emit("dialogCancel");
    },
    dialogConfirm() {
      this.$emit("dialogConfirm");
    },
    beforeClose() { }
  }
};
</script>

<style lang="scss">
.secondary-confirmation {
  position: relative;
  border-radius: 10px;

  .el-dialog__footer {
    padding: 0 !important;
  }

  .el-dialog__body {
    padding: 0;

    .dialog-content {
      margin-bottom: 20px;
      margin-top: 10px;
      .dialog-title {
		    margin-top:10px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4A83E8;
        line-height: 22px;
      }

      .kouchu-wrap {
        width: 180px;
        margin: 0 auto;
      }

      .confirm-text {
		    margin-top:10px;
        padding: 10px;
        text-align: center;
        font-size: 16px;
      }
      .sub-text {
        text-align: center;
        font-size: 14px;
      }

      .tips-1 {
        margin-top: 20px;
        margin-bottom: 20px;
        // text-align: center;
        font-size: 16px;
      }
      .kouchu-tips {
        width: 300px;
        text-align: left;
        margin: 10px auto;
        font-size: 16px;
      }

      .kouchu-money-ul {
        li {
          // text-align: center;
          margin-bottom: 10px;
          font-size: 16px;
        }
      }
    }

    .main-dialog-content {
      display: flex;
      flex-direction: column;
    }

    .warn-img {
      position: absolute;
      width: 100px;
      height: 100px;
      left: 50%;
      top: -50px;
      transform: translateX(-50px);
      // background-color: #fff;
      // border-radius: 50%;

      img {
        width: 100px;
        height: 100px;
      }
    }

    .text {
      width: 100%;
      text-align: center;
      padding: 0;
      margin-top: 25px;
      color: #4A83E8;
      font-size: 16px;
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: center;
    border-top: 1px solid #e8e8e8;

    .cancel-button {
      width: 50%;
      height: 50px;
      margin: 0;
      box-sizing: border-box;
      border-right: 1px solid #e8e8e8;
      color: #606266;
    }

    .confirm-button {
      width: 50%;
      height: 50px;
      margin: 0;
      color: #606266;
    }
  }
}</style>
